import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';

export default class extends Controller {
  static get targets() {
    return ['product', 'value'];
  } 

  connect(){
    this.productChanged();
  }

  productChanged(event) {
    var productField = $(this.productTarget);
    var productData = productField.find('option:selected').data('product');
    if (productData) {
      this.valueTarget.value = productData.average_price;
    }
  }
}
